import { JsonProperty, JsonObject, AbstractModel } from 'projects/core/src/public-api';

@JsonObject('model.cv.MaterialUnit')
export class MaterialUnit extends AbstractModel {

    @JsonProperty(Number, 'id')
    id: number;

    @JsonProperty(String, 'name')
    name?: string;

}